import { cn } from "@/modules/lib/utils"
import { HustleupSmallIcon } from "@images/svgIcons/hustleUpSmallIcon"

type TrainingAdsSectionProps = {} & React.ComponentProps<"div">

export function TrainingAdsSection({ className, ...props }: TrainingAdsSectionProps) {
  return (
    <div className={cn("relative flex w-3 flex-row overflow-hidden rounded-4xl bg-primary-500", className)} {...props}>
      <HustleupSmallIcon className="absolute top-0 right-0 z-0 h-full opacity-50" />
    </div>
  )
}
